"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileEntityType;
(function (FileEntityType) {
    FileEntityType["team"] = "team";
    FileEntityType["club"] = "club";
    FileEntityType["competitionLogo"] = "compLogo";
    FileEntityType["competitionWatermarkPrimary"] = "compWMPrimary";
    FileEntityType["competitionWatermarkSecondary"] = "compWMSecondary";
    FileEntityType["adFile"] = "ad";
    FileEntityType["player"] = "player";
    FileEntityType["teamPlayer"] = "teamPlayer";
    FileEntityType["user"] = "user";
    FileEntityType["venue"] = "venue";
    FileEntityType["organization"] = "organization";
})(FileEntityType = exports.FileEntityType || (exports.FileEntityType = {}));
var AdFileSize;
(function (AdFileSize) {
    AdFileSize["small"] = "small";
    AdFileSize["medium"] = "medium";
    AdFileSize["large"] = "large";
    AdFileSize["xLarge"] = "xLarge";
    AdFileSize["square"] = "square";
    AdFileSize["banner"] = "banner";
    AdFileSize["long"] = "long";
})(AdFileSize = exports.AdFileSize || (exports.AdFileSize = {}));
var AdAllocationEntityType;
(function (AdAllocationEntityType) {
    AdAllocationEntityType["team"] = "team";
    AdAllocationEntityType["competition"] = "competition";
})(AdAllocationEntityType = exports.AdAllocationEntityType || (exports.AdAllocationEntityType = {}));
var Sports;
(function (Sports) {
    Sports["football"] = "football";
    Sports["rugbyUnion"] = "rugbyUnion";
    Sports["rugbyLeague"] = "rugbyLeague";
    // basketball = 'basketball'
})(Sports = exports.Sports || (exports.Sports = {}));
//# sourceMappingURL=enums.js.map